export interface Options {
    label: string;
    value: any;
    name?: string;
    display?: string;
    reference?: any;
    selected?: boolean;
}

export interface FilterConfig {
    showSearch: boolean;
    showRequireAction: boolean;
}

export interface FilterField {
    key: string;
    type: 'text' | 'select' | 'date' | 'checkbox';
    label: string;
    filtro?: string;
    options?: Options[];
    visible?: boolean;
    searchTerm?: string;
    focus?: string;
    clearable?: boolean;
    displayText?: string;
    term?: string;
    dataKey?: string;
    targetKey?: string;
    placeholder?: string;
    multiple?: boolean;
    hiddenFor?: any;
    pairedWith?: string;
}

export const filters: { [key: string]: FilterField[] } = {
    automation: [
        {
            key: 'entity',
            type: 'select',
            label: 'Entidad',
            placeholder: 'entity',
            visible: true,
            searchTerm: '',
            focus: 'entity',
            displayText: '',
            dataKey: 'entity',
            targetKey: 'entities',
            filtro: 'eq', options: [],
        },
    ],
    orders: [
        {
            key: 'agent',
            type: 'select',
            label: 'Agente',
            placeholder: 'agent',
            visible: true,
            searchTerm: '',
            focus: 'agent',
            displayText: '',
            dataKey: 'broker_agent_id',
            targetKey: 'agentAccounts',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['supplier'] }
        },
        {
            key: 'sales_agent',
            type: 'select',
            label: 'Agente comercial',
            placeholder: 'sales_agent',
            visible: true,
            searchTerm: '',
            focus: 'sales_agent',
            displayText: '',
            dataKey: 'broker_sales_agent_id',
            targetKey: 'salesAgentAccounts',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['supplier'] }
        },
        {
            key: 'agent',
            type: 'select',
            label: 'Agente',
            placeholder: 'agent',
            visible: true,
            searchTerm: '',
            focus: 'agent',
            displayText: '',
            dataKey: 'supplier_agent_id',
            targetKey: 'agentAccounts',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['broker'] }
        },
        {
            key: 'campaign',
            type: 'select',
            label: 'Campaña',
            placeholder: 'campaign',
            visible: true,
            searchTerm: '',
            focus: 'campaign',
            displayText: '',
            dataKey: 'campaign_reference_id',
            targetKey: 'filteredCampaigns',
            filtro: 'in', options: []
        },
        {
            key: 'stage',
            type: 'select',
            label: 'Etapa',
            placeholder: 'stage',
            visible: true,
            searchTerm: '',
            focus: 'stage',
            displayText: '',
            dataKey: 'stage',
            targetKey: 'filteredStages',
            filtro: 'in', options: []
        },
        {
            key: 'broker',
            type: 'select',
            label: 'Broker',
            placeholder: 'broker',
            visible: true,
            searchTerm: '',
            focus: 'broker',
            displayText: '',
            dataKey: 'broker_reference_id',
            targetKey: 'brokerAccounts',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['broker'] }
        },
        {
            key: 'supplier',
            type: 'select',
            label: 'Proveedor',
            placeholder: 'supplier',
            visible: true,
            searchTerm: '',
            focus: 'supplier',
            displayText: '',
            dataKey: 'supplier_reference_id',
            targetKey: 'supplierAccounts',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['supplier'] }
        },
        {
            key: 'vendor',
            type: 'select',
            label: 'Vendedor',
            placeholder: 'vendor',
            visible: true,
            searchTerm: '',
            focus: 'vendor',
            displayText: '',
            dataKey: 'vendor_reference_id',
            targetKey: 'vendorAccounts',
            filtro: 'in', options: []
        },
        {
            key: 'delivery_status',
            type: 'select',
            label: 'Etapa de Entrega',
            placeholder: 'delivery_status',
            visible: true,
            searchTerm: '',
            focus: 'delivery_status',
            displayText: '',
            dataKey: 'delivery_status',
            targetKey: 'filteredDeliveryStages',
            filtro: 'in', options: []
        },
        {
            key: 'status',
            type: 'select',
            label: 'Estado',
            placeholder: 'status',
            visible: true,
            searchTerm: '',
            focus: 'status',
            displayText: '',
            dataKey: 'vehicle_status',
            targetKey: 'filteredStatus',
            filtro: 'eq', options: []
        },
        {
            key: 'brand',
            type: 'select',
            label: 'Marca',
            placeholder: 'vehicle_brand',
            visible: true,
            searchTerm: '',
            focus: 'brand',
            displayText: '',
            dataKey: 'vehicle_brand_id',
            targetKey: 'filteredBrands',
            filtro: 'in', options: []
        },
        {
            key: 'model',
            type: 'select',
            label: 'Modelo',
            placeholder: 'vehicle_model',
            visible: true,
            searchTerm: '',
            focus: 'model',
            displayText: '',
            dataKey: 'vehicle_model_id',
            targetKey: 'filteredModels',
            filtro: 'in', options: []
        },
        {
            key: 'workshop',
            type: 'select',
            label: 'Taller',
            placeholder: 'workshop',
            visible: true,
            searchTerm: '',
            focus: 'workshop',
            displayText: '',
            dataKey: 'workshop_reference_id',
            targetKey: 'filteredWorkshop',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['broker'] }
        },
        {
            key: 'supplier_type',
            type: 'select',
            label: 'Tipo de Proveedor',
            placeholder: 'supplier_type',
            visible: true,
            searchTerm: '',
            focus: 'supplier_type',
            displayText: '',
            dataKey: 'supplier_type',
            targetKey: 'filteredSupplierType',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['supplier'] }
        },
        {
            key: 'telemarketing_status',
            type: 'select',
            label: 'Estado Telemarketing',
            placeholder: 'telemarketing_status',
            visible: true,
            searchTerm: '',
            focus: 'telemarketing_status',
            displayText: '',
            dataKey: 'telemarketing_status',
            targetKey: 'telemarketingStatus',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['broker'], role: ['Pre-sales', 'Logistics', 'Workshop'] }
        },
        {
            key: 'telemarketing_action_status',
            type: 'select',
            label: 'Estado Acción Telemarketing',
            placeholder: 'telemarketing_action_status',
            visible: true,
            searchTerm: '',
            focus: 'telemarketing_action_status',
            displayText: '',
            dataKey: 'telemarketing_action_status',
            targetKey: 'telemarketingActionStatus',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['broker'], role: ['Pre-sales', 'Logistics', 'Workshop'] }
        },
        {
            key: 'tags',
            type: 'select',
            label: 'Etiquetas',
            placeholder: 'tags',
            visible: true,
            searchTerm: '',
            focus: 'tags',
            displayText: '',
            dataKey: 'tag_reference_id',
            targetKey: 'filteredTags',
            filtro: 'in', options: []
        },
        {
            key: 'client_type',
            type: 'select',
            label: 'Tipo de Cliente',
            placeholder: 'client_type',
            visible: true,
            searchTerm: '',
            focus: 'client_type',
            displayText: '',
            dataKey: 'client_type',
            targetKey: 'filteredClientTypes',
            filtro: 'in',
            options: []
        },
        {
            key: 'stage_from',
            type: 'select',
            label: 'Etapa desde',
            placeholder: 'stage_from',
            visible: true,
            searchTerm: '',
            focus: 'stage_from',
            displayText: '',
            dataKey: 'stage_from',
            targetKey: 'filteredStages',
            filtro: 'raw', options: [],
            pairedWith: 'stage_to'
        },
        {
            key: 'stage_to',
            type: 'select',
            label: 'Etapa hasta',
            placeholder: 'stage_to',
            visible: true,
            searchTerm: '',
            focus: 'stage_to',
            displayText: '',
            dataKey: 'stage_to',
            targetKey: 'filteredStages',
            filtro: 'raw', options: [],
            pairedWith: 'stage_from'
        },
    ],
    campaigns: [
        /* {
            key: 'stage',
            type: 'select',
            label: 'Etapa',
            placeholder: 'stage',
            visible: true,
            searchTerm: '',
            focus: 'stage',
            displayText: '',
            dataKey: 'stage',
            targetKey: 'filteredStages',
            filtro: 'in', 
            options: [],
            multiple: true
        },
        {
            key: 'campaign_stock_reference_id',
            type: 'select',
            label: 'Referencia de Stock de Campaña',
            placeholder: 'campaign_stock_reference_id',
            visible: true,
            searchTerm: '',
            focus: 'campaign_stock_reference_id',
            displayText: '',
            dataKey: 'campaign_stock_reference_id',
            targetKey: 'filteredCampaignStocks',
            filtro: 'in', 
            options: []
        }, */
        {
            key: 'broker',
            type: 'select',
            label: 'Broker',
            placeholder: 'broker',
            visible: true,
            searchTerm: '',
            focus: 'broker',
            displayText: '',
            dataKey: 'broker_reference_id',
            targetKey: 'brokerAccounts',
            filtro: 'in',
            options: [],
            multiple: true,
            hiddenFor: { accountType: ['broker'] }
        },
        {
            key: 'supplier',
            type: 'select',
            label: 'Proveedor',
            placeholder: 'supplier',
            visible: true,
            searchTerm: '',
            focus: 'supplier',
            displayText: '',
            dataKey: 'supplier_reference_id',
            targetKey: 'supplierAccounts',
            filtro: 'in',
            options: [],
            multiple: true,
            hiddenFor: { accountType: ['supplier'] }
        },
        {
            key: 'vendor',
            type: 'select',
            label: 'Vendedor',
            placeholder: 'vendor',
            visible: true,
            searchTerm: '',
            focus: 'vendor',
            displayText: '',
            dataKey: 'vendor_reference_id',
            targetKey: 'vendorAccounts',
            filtro: 'in',
            options: [],
            multiple: true
        }, {
            key: 'brand',
            type: 'select',
            label: 'Marca',
            placeholder: 'vehicle_brand',
            visible: true,
            searchTerm: '',
            focus: 'brand',
            displayText: '',
            dataKey: 'vehicle_brand_reference_id',
            targetKey: 'filteredBrands',
            filtro: 'in', options: []
        },
        {
            key: 'model',
            type: 'select',
            label: 'Modelo',
            placeholder: 'vehicle_model',
            visible: true,
            searchTerm: '',
            focus: 'model',
            displayText: '',
            dataKey: 'vehicle_model_reference_id',
            targetKey: 'filteredModels',
            filtro: 'in', options: []
        },
        {
            key: 'status',
            type: 'select',
            label: 'Estado',
            placeholder: 'status',
            visible: true,
            searchTerm: '',
            focus: 'status',
            displayText: '',
            dataKey: 'vehicle_status',
            targetKey: 'filteredStatus',
            filtro: 'eq',
            options: []
        },
    ],
    expanded: [
        {
            key: 'broker',
            type: 'select',
            label: 'Broker',
            placeholder: 'broker',
            visible: true,
            searchTerm: '',
            focus: 'broker',
            displayText: '',
            dataKey: 'broker_reference_id',
            targetKey: 'brokerAccounts',
            filtro: 'in',
            options: [],
            multiple: true,
            hiddenFor: { accountType: ['broker'] }
        },
        {
            key: 'supplier',
            type: 'select',
            label: 'Proveedor',
            placeholder: 'supplier',
            visible: true,
            searchTerm: '',
            focus: 'supplier',
            displayText: '',
            dataKey: 'supplier_reference_id',
            targetKey: 'supplierAccounts',
            filtro: 'in',
            options: [],
            multiple: true,
            hiddenFor: { accountType: ['supplier'] }
        },
        {
            key: 'vendor',
            type: 'select',
            label: 'Financiera',
            placeholder: 'vendor',
            visible: true,
            searchTerm: '',
            focus: 'vendor',
            displayText: '',
            dataKey: 'vendor_reference_id',
            targetKey: 'vendorAccounts',
            filtro: 'in',
            options: [],
            multiple: true
        },
        {
            key: 'brand',
            type: 'select',
            label: 'Marca',
            placeholder: 'vehicle_brand',
            visible: true,
            searchTerm: '',
            focus: 'brand',
            displayText: '',
            dataKey: 'vehicle_brand_reference_id',
            targetKey: 'filteredBrands',
            filtro: 'in',
            options: []
        },
        {
            key: 'model',
            type: 'select',
            label: 'Modelo',
            placeholder: 'vehicle_model',
            visible: true,
            searchTerm: '',
            focus: 'model',
            displayText: '',
            dataKey: 'vehicle_model_reference_id',
            targetKey: 'filteredModels',
            filtro: 'in',
            options: []
        },
        {
            key: 'status',
            type: 'select',
            label: 'Estado',
            placeholder: 'status',
            visible: true,
            searchTerm: '',
            focus: 'status',
            displayText: '',
            dataKey: 'vehicle_status',
            targetKey: 'filteredStatus',
            filtro: 'eq',
            options: []
        },
        {
            key: 'colour',
            type: 'text',
            label: 'Color',
            placeholder: 'colour',
            visible: true,
            searchTerm: '',
            focus: 'colour',
            displayText: '',
            dataKey: 'colour',
            targetKey: '',
            filtro: 'like',
            options: []
        },
        {
            key: 'campaign_stock_reference',
            type: 'text',
            label: 'Ref. Stock',
            placeholder: 'campaign_stock_reference',
            visible: true,
            searchTerm: '',
            focus: 'campaign_stock_reference',
            displayText: '',
            dataKey: 'campaign_stock_reference',
            targetKey: '',
            filtro: 'like',
            options: []
        },
    ],
    stocks: [
      
        {
            key: 'stage',
            type: 'select',
            label: 'Etapa',
            placeholder: 'stage',
            visible: true,
            searchTerm: '',
            focus: 'stage',
            displayText: '',
            dataKey: 'stage',
            targetKey: 'filteredStages',
            filtro: 'in',
            options: [],
            multiple: true
        },
        {
            key: 'broker',
            type: 'select',
            label: 'Broker',
            placeholder: 'broker',
            visible: true,
            searchTerm: '',
            focus: 'broker',
            displayText: '',
            dataKey: 'broker_reference_id',
            targetKey: 'brokerAccounts',
            filtro: 'in',
            options: [],
            multiple: true,
            hiddenFor: { accountType: ['broker'] }
        },
        {
            key: 'supplier',
            type: 'select',
            label: 'Proveedor',
            placeholder: 'supplier',
            visible: true,
            searchTerm: '',
            focus: 'supplier',
            displayText: '',
            dataKey: 'supplier_reference_id',
            targetKey: 'supplierAccounts',
            filtro: 'in',
            options: [],
            multiple: true,
            hiddenFor: { accountType: ['supplier'] }
        },
        {
            key: 'vendor',
            type: 'select',
            label: 'Vendedor',
            placeholder: 'vendor',
            visible: true,
            searchTerm: '',
            focus: 'vendor',
            displayText: '',
            dataKey: 'vendor_reference_id',
            targetKey: 'vendorAccounts',
            filtro: 'in',
            options: [],
            multiple: true
        }, {
            key: 'brand',
            type: 'select',
            label: 'Marca',
            placeholder: 'vehicle_brand',
            visible: true,
            searchTerm: '',
            focus: 'brand',
            displayText: '',
            dataKey: 'vehicle_brand_reference_id',
            targetKey: 'filteredBrands',
            filtro: 'in', options: []
        },
        {
            key: 'model',
            type: 'select',
            label: 'Modelo',
            placeholder: 'vehicle_model',
            visible: true,
            searchTerm: '',
            focus: 'model',
            displayText: '',
            dataKey: 'vehicle_model_reference_id',
            targetKey: 'filteredModels',
            filtro: 'in', options: []
        },
        {
            key: 'status',
            type: 'select',
            label: 'Estado',
            placeholder: 'status',
            visible: true,
            searchTerm: '',
            focus: 'status',
            displayText: '',
            dataKey: 'vehicle_status',
            targetKey: 'filteredStatus',
            filtro: 'eq',
            options: []
        },
          {
            key: 'vehicle_registered',
            type: 'select',
            label: 'Vehículo matriculado',
            placeholder: 'vehicle_registered',
            visible: true,
            searchTerm: '',
            focus: 'vehicle_registered',
            displayText: '',
            dataKey: 'vehicle_registered',
            targetKey: 'filteredStages',
            filtro: 'eq',
            options: []
        },
    ],
    clients: [
        {
            key: 'client_type',
            type: 'select',
            label: 'Tipo de Cliente',
            placeholder: 'client_type',
            visible: true,
            searchTerm: '',
            focus: 'client_type',
            displayText: '',
            dataKey: 'client_type',
            targetKey: 'filteredClientTypes',
            filtro: 'eq',
            options: []
        },
    ],
    todo: [
        {
            key: 'agent',
            type: 'select',
            label: 'Agente',
            placeholder: 'agent',
            visible: true,
            searchTerm: '',
            focus: 'agent',
            displayText: '',
            dataKey: 'broker_agent_id',
            targetKey: 'agentAccounts',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['supplier'] }
        },
        {
            key: 'agent',
            type: 'select',
            label: 'Agente',
            placeholder: 'agent',
            visible: true,
            searchTerm: '',
            focus: 'agent',
            displayText: '',
            dataKey: 'supplier_agent_id',
            targetKey: 'agentAccounts',
            filtro: 'in', options: [],
            hiddenFor: { accountType: ['broker'] }
        },

        {
            key: 'campaign',
            type: 'select',
            label: 'Campaña',
            placeholder: 'campaign',
            visible: true,
            searchTerm: '',
            focus: 'campaign',
            displayText: '',
            dataKey: 'campaigns_reference_id',
            targetKey: 'filteredCampaigns',
            filtro: 'in', options: []
        },
        {
            key: 'stage',
            type: 'select',
            label: 'Etapa',
            placeholder: 'stage',
            visible: true,
            searchTerm: '',
            focus: 'stage',
            displayText: '',
            dataKey: 'stages',
            targetKey: 'filteredStages',
            filtro: 'in', options: []
        },
        {
            key: 'broker',
            type: 'select',
            label: 'Broker',
            placeholder: 'broker',
            visible: true,
            searchTerm: '',
            focus: 'broker',
            displayText: '',
            dataKey: 'broker_reference_id',
            targetKey: 'brokerAccounts',
            filtro: 'in', options: []
        },
        {
            key: 'supplier',
            type: 'select',
            label: 'Proveedor',
            placeholder: 'supplier',
            visible: true,
            searchTerm: '',
            focus: 'supplier',
            displayText: '',
            dataKey: 'supplier_reference_id',
            targetKey: 'supplierAccounts',
            filtro: 'in', options: []
        },
        {
            key: 'vendor',
            type: 'select',
            label: 'Vendedor',
            placeholder: 'vendor',
            visible: true,
            searchTerm: '',
            focus: 'vendor',
            displayText: '',
            dataKey: 'vendor_reference_id',
            targetKey: 'vendorAccounts',
            filtro: 'in', options: []
        },
        {
            key: 'delivery_status',
            type: 'select',
            label: 'Etapa de Entrega',
            placeholder: 'delivery_status',
            visible: true,
            searchTerm: '',
            focus: 'delivery_status',
            displayText: '',
            dataKey: 'delivery_status',
            targetKey: 'filteredDeliveryStages',
            filtro: 'in', options: []
        },
        {
            key: 'status',
            type: 'select',
            label: 'Estado',
            placeholder: 'status',
            visible: true,
            searchTerm: '',
            focus: 'status',
            displayText: '',
            dataKey: 'vehicle_status',
            targetKey: 'filteredStatus',
            filtro: 'eq', options: []
        },
        {
            key: 'brand',
            type: 'select',
            label: 'Marca',
            placeholder: 'vehicle_brand',
            visible: true,
            searchTerm: '',
            focus: 'brand',
            displayText: '',
            dataKey: 'vehicle_brand_id',
            targetKey: 'filteredBrands',
            filtro: 'in', options: []
        },
        {
            key: 'model',
            type: 'select',
            label: 'Modelo',
            placeholder: 'vehicle_model',
            visible: true,
            searchTerm: '',
            focus: 'model',
            displayText: '',
            dataKey: '',
            targetKey: 'filteredModels',
            filtro: 'in', options: []
        },
        {
            key: 'workshop',
            type: 'select',
            label: 'Taller',
            placeholder: 'workshop',
            visible: true,
            searchTerm: '',
            focus: 'workshop',
            displayText: '',
            dataKey: 'workshop_reference_id',
            targetKey: 'filteredWorkshop',
            filtro: 'in', options: []
        },
        {
            key: 'supplier_type',
            type: 'select',
            label: 'Tipo de Proveedor',
            placeholder: 'supplier_type',
            visible: true,
            searchTerm: '',
            focus: 'supplier_type',
            displayText: '',
            dataKey: 'supplier_type',
            targetKey: 'filteredSupplierType',
            filtro: 'in', options: []
        },
        {
            key: 'campaign_reference_id',
            type: 'select',
            label: 'Referencia de Campaña',
            placeholder: 'campaign_reference_id',
            visible: true,
            searchTerm: '',
            focus: 'campaign_reference_id',
            displayText: '',
            dataKey: 'campaign_reference_id',
            targetKey: 'filteredSCampaignReferenceId',
            filtro: 'in', options: []
        },
        {
            key: 'telemarketing_status',
            type: 'select',
            label: 'Estado Telemarketing',
            placeholder: 'telemarketing_status',
            visible: true,
            searchTerm: '',
            focus: 'telemarketing_status',
            displayText: '',
            dataKey: 'telemarketing_status',
            targetKey: 'telemarketingStatus',
            filtro: 'in', options: []
        },
        {
            key: 'telemarketing_action_status',
            type: 'select',
            label: 'Estado Acción Telemarketing',
            placeholder: 'telemarketing_action_status',
            visible: true,
            searchTerm: '',
            focus: 'telemarketing_action_status',
            displayText: '',
            dataKey: 'telemarketing_action_status',
            targetKey: 'telemarketingActionStatus',
            filtro: 'in', options: []
        },
    ],
};

export const filtersDates: { [key: string]: FilterField[] } = {
    orders: [
        // Filtro de fechas
        {
            key: 'contract_accepted_date',
            type: 'date',
            label: 'Fecha de Aceptación de Contrato',
            placeholder: 'contract_accepted_date',
            visible: true,
            searchTerm: '',
            focus: 'contract_accepted_date',
            displayText: '',
            dataKey: 'contract_accepted_date',
            targetKey: 'contractAcceptedDate',
            filtro: 'between', options: []
        },
        {
            key: 'vehicle_registration_date',
            type: 'date',
            label: 'Fecha de Matriculación',
            placeholder: 'vehicle_registration_date',
            visible: true,
            searchTerm: '',
            focus: 'vehicle_registration_date',
            displayText: '',
            dataKey: 'vehicle_registration_date',
            targetKey: 'vehicleRegistrationDates',
            filtro: 'between', options: []
        },
        {
            key: 'stage_date_range',
            type: 'date',
            label: 'Fecha entrada a etapa',
            placeholder: 'stage_date_range',
            visible: true,
            searchTerm: '',
            focus: 'stage_date_range',
            displayText: '',
            dataKey: 'stage_date_range',
            targetKey: 'stageDateRange',
            filtro: 'raw_date', options: []
        },
    ],
    todo: [
        // Filtro de fechas
        {
            key: 'contract_signed_date',
            type: 'date',
            label: 'Fecha de Firma de Contrato',
            placeholder: 'contract_signed_date',
            visible: true,
            searchTerm: '',
            focus: 'contract_signed_date',
            displayText: '',
            dataKey: 'contract_signed_date',
            targetKey: 'contractSignedDate',
            filtro: 'between', options: []
        },
        {
            key: 'contract_accepted_date',
            type: 'date',
            label: 'Fecha de Aceptación de Contrato',
            placeholder: 'contract_accepted_date',
            visible: true,
            searchTerm: '',
            focus: 'contract_accepted_date',
            displayText: '',
            dataKey: 'contract_accepted_date',
            targetKey: 'contractAcceptedDate',
            filtro: 'between', options: []
        },
        {
            key: 'vehicle_registration_date',
            type: 'date',
            label: 'Fecha de Matriculación',
            placeholder: 'vehicle_registration_date',
            visible: true,
            searchTerm: '',
            focus: 'vehicle_registration_date',
            displayText: '',
            dataKey: 'vehicle_registration_date',
            targetKey: 'vehicleRegistrationDates',
            filtro: 'between', options: []
        },
    ]
};

/* Configuración de elementos UI por tipo */
export const filterUIConfig: { [key: string]: FilterConfig } = {
    orders: {
        showSearch: true,
        showRequireAction: true
    },
    campaigns: {
        showSearch: true,
        showRequireAction: false
    },
    stocks: {
        showSearch: true,
        showRequireAction: false
    },
    expanded: {
        showSearch: true,
        showRequireAction: false
    },
    automation: {
        showSearch: false,
        showRequireAction: false
    },
    todo: {
        showSearch: true,
        showRequireAction: true
    },
    clients: {
        showSearch: true,
        showRequireAction: false
    },
    invoices: {
        showSearch: true,
        showRequireAction: true
    },
    // Configuración por defecto para tipos no definidos
    default: {
        showSearch: true,
        showRequireAction: true
    }
};


